import React from "react";
import { useDispatch } from "react-redux";
import { formSet } from "../../actions/appActions";
import { initialCpdEvent } from "../../constants/factories";
import { AddCircle } from "@mui/icons-material";
import { Button } from "@mui/material";
import { TYPE_CPD_EVENT } from "../../api/api";
import CpdEventList from "./CpdEventList";

const CpdEvent = () => {
  const dispatch = useDispatch();

  const handleCreate = () => {
    dispatch(formSet(TYPE_CPD_EVENT, { ...initialCpdEvent }));
  };

  return (
    <>
      <Button
        sx={{ mt: 2, mb: 2 }}
        onClick={handleCreate}
        color="primary"
        variant="contained"
        disableElevation
        startIcon={<AddCircle />}
      >
        Vytvořit akci
      </Button>
      <CpdEventList />
    </>
  );
};

export default CpdEvent;
